export default __webpack_public_path__ + "static/media/img5.a6c98493.jpg";